module.exports = __webpack_public_path__ + "img/confraternizacion.7d6dccff.jpg";